<template>
  <div
    class="extraBlock"
    :style="isOpen ? 'flex-direction:row;' : 'flex-direction:column;'"
  >
    <div v-if="menu && extraBlock[0]" class="menu">
      <FormButtons
        v-if="extraBlock.length"
        :buttons_menu="[[{ ...extraBlock[0], colorVisualClass: 'blue' }]]"
      ></FormButtons>
    </div>
    <div v-if="search" class="search">
      <div
        v-show="!isOpen"
        class="search__icon"
        @click="activeSearch"
        :style="!isOpen ? 'margin: 8px 0; width: 40px; height: 40px;' : ''"
      >
        <Icon iconName="Search" iconColor="#788694" />
      </div>
      <div
        v-show="isOpen"
        class="search__input"
        :class="!extraBlock[0] ? 'full' : ''"
        :style="progress ? 'margin:0 0 0 16px' : 'margin:0 8px 0 0'"
      >
        <form @submit.prevent="sendSearch">
          <Input
            ref="search_input"
            :field="{ name: 'search' }"
            :model="search.value"
            prefixIcon="Search"
            @set-value="
              (name, val) => {
                search.value = val;
              }
            "
          />
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import FormButtons from 'Elements/Form/FormButtons';
import Icon from 'Elements/Icon/Icon';
import Input from 'Elements/Input/Input';
import { eventBus } from '@/bus';
export default {
  props: {
    extraBlock: {
      type: Array,
      required: true,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      menu: {},
      search: {},
      progress: {}
    };
  },
  mounted() {
    if (this.extraBlock && this.extraBlock.length) {
      this.menu = this.extraBlock[0];
      this.search = { ...this.extraBlock[1], value: '' };
    }
    // this.progress = this.extraBlock[2];
  },
  methods: {
    activeSearch() {
      this.$nextTick(() => {
        eventBus.$emit('openMenu');
        const searchInputRef = this.$refs.search_input.$children[0];
        searchInputRef.focus();
      });
    },
    sendSearch() {
      let fieldsData = {};
      fieldsData['search_text'] = this.search.value;
      fieldsData['search_area'] = 'full_name_and_means_of_communications';
      fieldsData['search_type'] = 'all_words';
      fieldsData['where_to_search'] = 'HRPAC_CANDIDATES';
      localStorage.setItem('search_data', JSON.stringify(fieldsData));
      this.$router.push(`/global_search`);
      this.search.value = '';
    }
  },
  components: {
    FormButtons,
    Icon,
    Input
  }
};
</script>

<style lang="scss" scoped>
.extraBlock {
  display: flex;
  justify-items: center;
  align-items: center;
  box-sizing: border-box;
  padding-left: 16px;

  .menu {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    width: 40px;
    height: 40px;
    background-color: $grey12;
    box-sizing: border-box;

    &::v-deep .el-dropdown {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &::v-deep .buttons-panel__buttons {
      height: 40px;
    }

    &::v-deep .el-dropdown-selfdefine {
      padding: 4px 8px;
    }
  }

  .search {
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      border: 1px solid $grey16;
      cursor: pointer;
      box-sizing: border-box;
    }

    &__input {
      width: 224px;
    }

    .full {
      width: 250px;
    }
  }
}

@media (max-height: 600px) {
  .extraBlock {
    .search {
      &__icon {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
